import { render, staticRenderFns } from "./TransactionSubscription.vue?vue&type=template&id=252f2b02&"
import script from "./TransactionSubscription.vue?vue&type=script&lang=ts&"
export * from "./TransactionSubscription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports